/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Profile_SavedInputs */

const th_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกโปรไฟล์แล้ว`)
};

const en_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile saved.`)
};

const ja_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィールを保存しました。`)
};

const zh_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资料已保存。`)
};

const es_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil guardado.`)
};

const pt_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil salvo.`)
};

const id_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil tersimpan.`)
};

const fr_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil enregistré.`)
};

const tl_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-save ang profile.`)
};

const vi_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu hồ sơ.`)
};

const ko_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로필을 저장했습니다.`)
};

const de_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil gespeichert.`)
};

const ru_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профиль сохранён.`)
};

const tr_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil kaydedildi.`)
};

const it_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo salvato.`)
};

const pl_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil zapisany.`)
};

const uk_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профіль збережено.`)
};

const hi_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल सहेजी गई।`)
};

const ar_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حُفظ الملف.`)
};

const ms_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil disimpan.`)
};

const bn_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রোফাইল সংরক্ষিত হয়েছে।`)
};

const zh_tw2_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`資料已儲存。`)
};

const zh_hk2_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`資料已儲存。`)
};

const ur_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پروفائل محفوظ ہو گیا۔`)
};

const fa_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نمایه ذخیره شد.`)
};

const sw_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasifu umehifadhiwa.`)
};

const nl_org_profile_saved = /** @type {(inputs: Org_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiel opgeslagen.`)
};

/**
* | output |
* | --- |
* | "Profile saved." |
*
* @param {Org_Profile_SavedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_profile_saved = /** @type {((inputs?: Org_Profile_SavedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Profile_SavedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_profile_saved(inputs)
	if (locale === "ja") return ja_org_profile_saved(inputs)
	if (locale === "zh") return zh_org_profile_saved(inputs)
	if (locale === "es") return es_org_profile_saved(inputs)
	if (locale === "pt") return pt_org_profile_saved(inputs)
	if (locale === "id") return id_org_profile_saved(inputs)
	if (locale === "fr") return fr_org_profile_saved(inputs)
	if (locale === "tl") return tl_org_profile_saved(inputs)
	if (locale === "vi") return vi_org_profile_saved(inputs)
	if (locale === "ko") return ko_org_profile_saved(inputs)
	if (locale === "de") return de_org_profile_saved(inputs)
	if (locale === "ru") return ru_org_profile_saved(inputs)
	if (locale === "tr") return tr_org_profile_saved(inputs)
	if (locale === "it") return it_org_profile_saved(inputs)
	if (locale === "pl") return pl_org_profile_saved(inputs)
	if (locale === "uk") return uk_org_profile_saved(inputs)
	if (locale === "hi") return hi_org_profile_saved(inputs)
	if (locale === "ar") return ar_org_profile_saved(inputs)
	if (locale === "ms") return ms_org_profile_saved(inputs)
	if (locale === "bn") return bn_org_profile_saved(inputs)
	if (locale === "zh-TW") return zh_tw2_org_profile_saved(inputs)
	if (locale === "zh-HK") return zh_hk2_org_profile_saved(inputs)
	if (locale === "ur") return ur_org_profile_saved(inputs)
	if (locale === "fa") return fa_org_profile_saved(inputs)
	if (locale === "sw") return sw_org_profile_saved(inputs)
	if (locale === "nl") return nl_org_profile_saved(inputs)
	return en_org_profile_saved(inputs)
});